import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import CarrierService from "../app/data/carriers/carriersServices";

const carrierService = CarrierService.getInstance();

export const useCarriersList = (search?: string) => {
  return useInfiniteQuery({
    queryKey: ["GET_CARRIERS_LIST", search],
    queryFn: ({ pageParam = 0 }) => carrierService.getcarriersList(search, pageParam),
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage?.data?.number ?? 0;
      const totalPages = lastPage?.data?.totalPages ?? 0;
      return currentPage + 1 < totalPages ? currentPage + 1 : undefined;
    },
    select: (data) => {
      const allItems = data.pages.flatMap((p) => p.data.content);
      return { ...data, allItems };
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCarriersListDetails = (carrierNumber: number) => {
  return useQuery({
    queryKey: ["GET_CARRIERS_DETAIL", carrierNumber],
    queryFn: () => carrierService.getCarrierDetails(carrierNumber),
    enabled: !!carrierNumber,
    staleTime: 1000 * 60 * 5,
  });
};

// CREATE
export const useCreateCarrier = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: any) => CarrierService.getInstance().createCarrier(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GET_CARRIERS_LIST"] }); // 3. Invalidate the list query
      },
      onError: (error: any) => {
        throw new Error(error.message);
      }
    }
  );
};

// UPDATE
export const useUpdateCarrier = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, payload }: any) => CarrierService.getInstance().updateCarrier(id, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GET_CARRIERS_LIST"] });
      },
      onError: (error: any) => {
        throw new Error(error.message);
      }
    }
  );
};

// DELETE
export const useDeleteCarrier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => carrierService.deleteCarrier(id),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET_CARRIERS_LIST"] });
    },
  });
};

// DOWNLOAD CSV
export const useDownloadCSVCarrier = () => {
  return useMutation({
    mutationFn: (search: string) => carrierService.getDownloadCSVCarrier(search),
  });
};
